import React from 'react';
import PropTypes from 'prop-types';
import {
  BulkPlaybookUpdateTableContextProvider,
  useBulkPlaybookUpdateTableContext,
} from './BulkPlaybookUpdateTableContext';
import {
  BulkPlaybookUpdateModalContextProvider,
  useBulkPlaybookUpdateModalContext,
  BULK_PLAYBOOK_UPDATE_MODALS,
} from './BulkPlaybookUpdateModalContext';
import BulkPlaybookUpdateTable from './BulkPlaybookUpdateTable';
import ConfirmUpdateModal from './modals/ConfirmUpdateModal';
import ConfirmCancelModal from './modals/ConfirmCancelModal';

function BulkPlaybookUpdateTableContent({ onExit }) {
  const { selectedCount, clearSelection, selectedPlaybookId } = useBulkPlaybookUpdateTableContext();
  const { onOpenModal } = useBulkPlaybookUpdateModalContext();

  const handleCancel = () => {
    if (selectedCount > 0) {
      onOpenModal(BULK_PLAYBOOK_UPDATE_MODALS.CONFIRM_CANCEL);
    } else {
      onExit();
    }
  };

  const handleConfirmCancel = () => {
    clearSelection();
    onExit();
  };

  const handleSuccess = () => {
    onExit();
  };

  return (
    <>
      <BulkPlaybookUpdateTable onCancel={handleCancel} />
      <ConfirmUpdateModal key={selectedPlaybookId || '_UNSET_'} onSuccess={handleSuccess} />
      <ConfirmCancelModal onConfirm={handleConfirmCancel} />
    </>
  );
}

export default function BulkPlaybookUpdateTableWrapper({ onExit }) {
  return (
    <BulkPlaybookUpdateTableContextProvider>
      <BulkPlaybookUpdateModalContextProvider>
        <BulkPlaybookUpdateTableContent onExit={onExit} />
      </BulkPlaybookUpdateModalContextProvider>
    </BulkPlaybookUpdateTableContextProvider>
  );
}

BulkPlaybookUpdateTableContent.propTypes = {
  onExit: PropTypes.func.isRequired,
};

BulkPlaybookUpdateTableWrapper.propTypes = {
  onExit: PropTypes.func.isRequired,
};
